import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { useCurrentModule } from '@/hooks/useCurrentModule';
import { handleSupabaseError } from '@/lib/errors/handleSupabaseError';

export interface UserStreak {
  current_streak: number;
  longest_streak: number;
}

export function useUserStreak() {
  const { user } = useAuth();
  const moduleType = useCurrentModule();

  return useQuery<UserStreak | null>({
    queryKey: ['user-streak', user?.id, moduleType],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      if (!user) return null;
      const { data, error } = await supabase
        .from('user_streaks')
        .select('current_streak, longest_streak')
        .eq('user_id', user.id)
        .eq('module_type', moduleType)
        .maybeSingle();
      if (error) {
        handleSupabaseError(error, undefined, { context: { source: 'useUserStreak' }, silent: true });
        return null;
      }
      return data;
    },
  });
}
